import {
  CaraPerio,
  CarasPerioDatos,
  EntradaDientePerio,
  Furca,
  Pronostico,
} from "app/models/periodontograma.interface";

export const CARAS_PERIO: CaraPerio[] = ["vestibular", "palatino"];
export const SITIOS = ["mesial", "central", "distal"];
export const FURCAS: Furca[] = ["I", "II", "III", "IV"];

export type PronosticoItem = { valor: Pronostico; label: string; color: string };

export const PRONOSTICOS: PronosticoItem[] = [
  { valor: "bueno", label: "Bueno", color: "#2e7d32" },
  { valor: "regular", label: "Regular", color: "#f9a825" },
  { valor: "malo", label: "Malo", color: "#e53935" },
  { valor: "cuestionable", label: "Cuestionable", color: "#757575" },
  { valor: "sin_esperanza", label: "Sin esperanza", color: "#b71c1c" },
];

export function caraVacia(): CarasPerioDatos {
  return {
    sondaje: [null, null, null],
    margen: [null, null, null],
    sangrado: [false, false, false],
    supuracion: [false, false, false],
    placa: [false, false, false],
    anchura: null,
  };
}

export function entradaVacia(): EntradaDientePerio {
  return {
    presente: true,
    implante: false,
    movilidad: null,
    furca: null,
    pronostico: null,
    vestibular: caraVacia(),
    palatino: caraVacia(),
  };
}

export function entradaEsVacia(e: EntradaDientePerio): boolean {
  if (e.movilidad !== null || e.furca !== null || e.pronostico !== null || e.implante) return false;
  for (const cara of CARAS_PERIO) {
    const d = e[cara];
    if (d.sondaje.some((v) => v !== null)) return false;
    if (d.margen.some((v) => v !== null)) return false;
    if (d.sangrado.some((v) => v)) return false;
    if (d.supuracion.some((v) => v)) return false;
    if (d.placa.some((v) => v)) return false;
    if (d.anchura !== null) return false;
  }
  return true;
}
